import React, { useContext, useEffect } from "react";
import { Grid, List, ListItemButton, ListItemText, ListItemIcon, Select, MenuItem, Button } from "@mui/material";
import { Dashboard, EmojiEvents, TrendingUp, Scoreboard, PeopleAlt, Settings, PersonOff, CardMembership } from "@mui/icons-material";
import { Link, useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import UserContext from "../../../context/UserContext";
import { ROUTES } from "constants/routes";
import { getOrganizationRoute } from "network/api-routes";
import performRequest from "network/perform-request";

const OrganizationDrawer = () => {
  const { user, selectedOrganization, setSelectedOrganization } = useContext(UserContext);
  const history = useHistory();
  const intl = useIntl();

  useEffect(() => {
    if (user.organizations && !selectedOrganization) {
      handleOrganizationChange(user.organizations[0].id);
    }
  }, []);

  const handleOrganizationChange = (organizationID) => {
    performRequest("GET", getOrganizationRoute, { id: organizationID }, true, user)
      .then((res) => {
        history.push(ROUTES.ADMIN.ORGANIZATIONS);
        setSelectedOrganization(res.data); // se guarda en el contexto
      })
      .catch((err) => console.error(err));
  };

  const createMenuItem = (id, Icon, routeSuffix = "", count = null) => ({
    label: intl.formatMessage({ id }),
    icon: <Icon />,
    link: `${ROUTES.ADMIN.ORGANIZATIONS}${routeSuffix}`,
    count,
  });

  const menuItems = [
    createMenuItem("Página principal", Dashboard),
    createMenuItem("Rankings", EmojiEvents, "/classifications"),
    createMenuItem("Eventos de ranking", TrendingUp, "/classification-events"),
    createMenuItem("Sistemas de puntuación", Scoreboard, "/punctuations"),
    createMenuItem("Miembros", PeopleAlt, "/members"),
    createMenuItem("Cuota federativa", CardMembership, "/membership-settings"),
    createMenuItem(
      "Jugadores no vinculados",
      PersonOff,
      "/unlinked-players",
      selectedOrganization?.unlinked_players_count || 0
    ),
    createMenuItem("Ajustes", Settings, "/settings"), // <- Nueva línea
  ];

  return (
    <Grid>
      <Select
        sx={{ width: "100%" }}
        value={selectedOrganization?.id || ""}
        onChange={(e) => handleOrganizationChange(e.target.value)}
      >
        {user?.organizations?.map((org) => (
          <MenuItem key={org.id} value={org.id}>
            {org.name}
          </MenuItem>
        ))}
      </Select>

      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 1 }}
        onClick={() => history.push(`${ROUTES.PUBLIC.ORGANIZATION}/${selectedOrganization.slug}`)}
      >
        {intl.formatMessage({ id: "Ver página pública" })}
      </Button>

      <List>
        {menuItems.map(({ label, icon, link, count }) => (
          <ListItemButton key={label} component={Link} to={link}>
            <ListItemIcon sx={{ minWidth: 30 }}>{icon}</ListItemIcon>
            <ListItemText primary={count > 0 ? `${label} (${count})` : label} />
          </ListItemButton>
        ))}
      </List>
    </Grid>
  );
};

export default OrganizationDrawer;
